import { render, staticRenderFns } from "./ClientsPage.vue?vue&type=template&id=9a7f337a&"
import script from "./ClientsPage.vue?vue&type=script&lang=js&"
export * from "./ClientsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a7f337a')) {
      api.createRecord('9a7f337a', component.options)
    } else {
      api.reload('9a7f337a', component.options)
    }
    module.hot.accept("./ClientsPage.vue?vue&type=template&id=9a7f337a&", function () {
      api.rerender('9a7f337a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ClientsPage.vue"
export default component.exports